var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#FE0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 18.9063C36.5625 17.8125 35.7813 17.0313 34.6875 16.7188C32.8125 16.25 24.8437 16.25 24.8437 16.25C24.8437 16.25 17.0313 16.25 15 16.7188C13.9063 17.0313 13.125 17.8125 12.8125 18.9063C12.5 20.9375 12.5 25 12.5 25C12.5 25 12.5 29.0625 12.9688 31.0938C13.2813 32.1875 14.0625 32.9688 15.1562 33.2812C17.0312 33.75 25 33.75 25 33.75C25 33.75 32.8125 33.75 34.8437 33.2812C35.9375 32.9688 36.7188 32.1875 37.0313 31.0938C37.5 29.0625 37.5 25 37.5 25C37.5 25 37.5 20.9375 36.875 18.9063ZM22.5 28.75V21.25L29.0625 25L22.5 28.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.b5daa8b2007e8c04fa4b98d6a7b66d41.svg";
export { ForwardRef as ReactComponent };